/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowsOutSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M216,48V96a8.00018,8.00018,0,0,1-13.65723,5.65674L184,83.314l-26.34277,26.34278a8.00018,8.00018,0,0,1-11.31446-11.31348L172.686,72,154.34277,53.65674A8.00038,8.00038,0,0,1,160,40h48A8.00008,8.00008,0,0,1,216,48ZM98.34277,146.34326,72,172.686,53.65723,154.34326A8.0001,8.0001,0,0,0,40,160v48a8.00008,8.00008,0,0,0,8,8H96a8.00038,8.00038,0,0,0,5.65723-13.65674L83.314,184l26.34327-26.34326a8.00018,8.00018,0,0,0-11.31446-11.31348Z" />
    </Svg>
  );
}

export default ArrowsOutSimple;
